/** First-run guided tour (ADR-0055). */
export default {
  en: {
    label: "Guided tour",
    next: "Next",
    back: "Back",
    done: "Finish",
    skip: "Skip tour",
    stepOf: "Step {{n}} of {{total}}",
    steps: {
      welcome: { title: "Welcome to the Agent Platform", body: "This short tour shows where things are. It takes under a minute, and you can replay it from Help at any time." },
      nav: { title: "Your pages", body: "The pages your roles allow are grouped into Work, Build, Govern and Observe. You only see what you can use." },
      palette: { title: "Search or jump", body: "Type the name of a page or an action here, or press Ctrl+K (⌘K on Mac) from anywhere." },
      bell: { title: "What needs you", body: "This bell counts the things waiting for you, such as tasks to approve. Open it to go straight there." },
      help: { title: "Help on every page", body: "Not sure what a page is for? Open Help for a short explanation, the user guide and the glossary." },
      home: { title: "Start from Home", body: "Home shows what needs you now and suggests where to start." },
      agentPicker: { title: "Pick an agent", body: "Choose which agent to talk to, then type your question below." },
    },
  },
  ar: {
    label: "جولة تعريفية",
    next: "التالي",
    back: "السابق",
    done: "إنهاء",
    skip: "تخطي الجولة",
    stepOf: "الخطوة {{n}} من {{total}}",
    steps: {
      welcome: { title: "مرحبًا بك في منصة الوكلاء", body: "تعرض هذه الجولة القصيرة مواضع الأشياء. تستغرق أقل من دقيقة، ويمكنك إعادتها من المساعدة في أي وقت." },
      nav: { title: "صفحاتك", body: "الصفحات التي تسمح بها أدوارك مجمعة في: العمل والبناء والحوكمة والمراقبة. لا ترى إلا ما يمكنك استخدامه." },
      palette: { title: "ابحث أو انتقل", body: "اكتب اسم صفحة أو إجراء هنا، أو اضغط Ctrl+K (أو ⌘K على ماك) من أي مكان." },
      bell: { title: "ما يحتاج إليك", body: "يحصي هذا الجرس ما ينتظرك، مثل المهام التي تحتاج إلى اعتماد. افتحه لتنتقل إليها مباشرة." },
      help: { title: "مساعدة في كل صفحة", body: "لست متأكدًا من الغرض من صفحة؟ افتح المساعدة لشرح قصير ودليل المستخدم والمصطلحات." },
      home: { title: "ابدأ من الرئيسية", body: "تعرض الرئيسية ما يحتاج إليك الآن وتقترح من أين تبدأ." },
      agentPicker: { title: "اختر وكيلًا", body: "اختر الوكيل الذي تريد التحدث إليه، ثم اكتب سؤالك في الأسفل." },
    },
  },
};
